export { findElement, getElementPath, elementIsVisible } from '../extensions/product-tours/element-inference'
